import { useState } from "react";

/**
 * Página do link de redefinição de senha.
 *
 * Servida pelo catch-all do SPA em `/redefinir-senha?token=...`. O token vem na
 * URL e só é conferido no servidor - aqui ele é apenas repassado.
 */
export function ResetPasswordPage() {
  const token = new URLSearchParams(window.location.search).get("token") ?? "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy) return;
    if (password !== confirm) {
      setError("As senhas não conferem.");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      const r = await fetch("/api/auth/reset-password", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ token, password, confirm }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) {
        setError(j.error ?? "Não foi possível redefinir a senha.");
        return;
      }
      // a rota já autentica: recarregar leva direto para dentro do app
      window.location.href = "/";
    } catch {
      setError("Falha de conexão.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Definir nova senha</h1>

        {!token ? (
          /* sem token não há o que fazer: dizer isso é melhor que um formulário
             que só vai falhar no envio */
          <>
            <p className="auth-sub">
              Link incompleto. Abra o link exatamente como ele chegou para você, ou peça um novo ao
              administrador.
            </p>
            <a className="auth-submit" href="/" style={{ display: "block", textAlign: "center" }}>
              Ir para o login
            </a>
          </>
        ) : (
          <form onSubmit={submit} className="auth-form">
            <label className="auth-field">
              <span>Nova senha</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mínimo 8 caracteres"
                autoComplete="new-password"
                minLength={8}
                required
              />
            </label>

            <label className="auth-field">
              <span>Repetir a nova senha</span>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Repita para confirmar"
                autoComplete="new-password"
                minLength={8}
                required
              />
            </label>

            {error && <div className="auth-error">{error}</div>}

            <button type="submit" className="auth-submit" disabled={busy}>
              {busy ? "Salvando…" : "Salvar nova senha"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
